import type { Dispatch, SetStateAction } from 'react';

import { CheckCircleOutlined, TeamOutlined } from '@ant-design/icons';
import { Checkbox, Tag } from 'antd';
import type { ColumnType } from 'antd/es/table';

import type { ITest } from '@/api/endpoints/schools/schoolSelectionPanel';
import { CustomTable } from '@/shared/components';
import { toggleSetItem } from '@/shared/helpers';

import styles from './UsersAssignmentPage.module.scss';

export const getSuccessTestsColumnsData = ({
  mainListUsersIds,
  setMainListUsersIds,
}: {
  mainListUsersIds: Set<number>;
  setMainListUsersIds: Dispatch<SetStateAction<Set<number>>>;
}) =>
  [
    {
      title: '',
      key: 'checkbox',
      width: 40,
      render: (_, { id }) => (
        <Checkbox
          checked={mainListUsersIds.has(id)}
          onClick={(event) => {
            event.stopPropagation();
            setMainListUsersIds((prev) => toggleSetItem(prev, id));
          }}
        />
      ),
    },
    {
      title: 'ФИО',
      dataIndex: ['user', 'full_name'],
      key: 'name',
      ellipsis: true,
    },
    {
      title: 'Email',
      dataIndex: ['user', 'email'],
      key: 'email',
      ellipsis: true,
    },
    {
      title: 'Телефон',
      dataIndex: ['user', 'phone'],
      key: 'phone',
      ellipsis: true,
      render: (_, { user }) => user.phone || '-',
    },
    {
      title: 'Список',
      dataIndex: 'status',
      key: 'status',
      ellipsis: true,
      render: (_, { id }) => (
        <Tag
          className={styles.tag}
          color={mainListUsersIds.has(id) ? 'green' : 'yellow'}
          icon={mainListUsersIds.has(id) ? <CheckCircleOutlined /> : <TeamOutlined />}
        >
          {mainListUsersIds.has(id) ? 'Основной' : 'Резерв'}
        </Tag>
      ),
    },
  ] as ColumnType<ITest>[];

const getFailedTestsColumnsData = () =>
  [
    {
      title: 'ФИО',
      dataIndex: ['user', 'full_name'],
      key: 'name',
      ellipsis: true,
    },
    {
      title: 'Email',
      dataIndex: ['user', 'email'],
      key: 'email',
      ellipsis: true,
    },
    {
      title: 'Телефон',
      dataIndex: ['user', 'phone'],
      key: 'phone',
      ellipsis: true,
      render: (_, { user }) => user.phone || '-',
    },
  ] as ColumnType<ITest>[];

export const getCollapseItems = ({ failedTestingData }: { failedTestingData: ITest[] }) => [
  {
    key: '1',
    label: 'Участники со статусом "Тест не сдан"',
    children: (
      <CustomTable
        className={styles['test-failed-table']}
        rowKey="id"
        pagination={false}
        dataSource={failedTestingData}
        columns={getFailedTestsColumnsData()}
        scroll={{ y: 54 * 10 }}
      />
    ),
  },
];
